import pauseIcon from "@assets/pulse/pause.svg";
import playIcon from "@assets/pulse/play.svg";
import useSendPulseGaData from "@features/pulse/hooks/useSendPulseGaData";
import { SanitizedPulseData } from "@features/pulse/utils/types";
import { AUTOPLAY_INTERVAL } from "@features/pulse/variant/others/utils/constants";
import { PulseAutoPlayPaginationProps } from "@features/pulse/variant/others/utils/types";
import { cn } from "@util/helpers";

type PulseMobileAutoPlayPaginationProps = {
  displayArticle: SanitizedPulseData;
} & Omit<PulseAutoPlayPaginationProps, "handleSetIsAutoplayPaused">;

/** Mobile Autoplay component for pulse variant manual and autoplay
 * includes pause/play button and progress bar*/
const PulseMobileAutoPlayPagination = ({
  isFront,
  autoplayTotal,
  setIsAutoplayEnabled,
  isAutoplayEnabled,
  resetAutoplayLeft,
  activeArticle,
  displayArticle,
}: PulseMobileAutoPlayPaginationProps) => {
  const { sendCustomEvent } = useSendPulseGaData();

  const handleIsEnabled = () => {
    setIsAutoplayEnabled((prev) => !prev);
    resetAutoplayLeft();

    sendCustomEvent(
      `mobile::${isAutoplayEnabled ? "pause" : "play"}::${activeArticle}`,
      displayArticle.title
    );
  };

  return (
    <div
      className="mb-auto flex w-full items-center justify-between gap-[10px]"
      data-testid="pulse-mobile-autoplay-pagination-component"
    >
      <button
        onClick={handleIsEnabled}
        className="flex h-8 w-8 items-center justify-center rounded-full bg-black/25"
      >
        {isAutoplayEnabled ? (
          <img src={pauseIcon} alt={"Pause autoplay"} width={13} height={18} />
        ) : (
          <img src={playIcon} alt={"Play autoplay"} width={14} height={18} />
        )}
      </button>

      <div
        className={cn(
          "h-[3px] flex-1 overflow-hidden rounded-full bg-black/50 transition-all duration-150",
          {
            "opacity-0 ": !isAutoplayEnabled,
          }
        )}
      >
        <div
          className={cn(
            "h-full w-0 bg-white transition-all duration-1000 ease-linear",
            { "duration-0": !isAutoplayEnabled }
          )}
          style={{
            width: isFront
              ? `${(autoplayTotal / (AUTOPLAY_INTERVAL - 1000)) * 100}%`
              : 0,
          }}
        />
      </div>
    </div>
  );
};

export default PulseMobileAutoPlayPagination;
